<template>
  <section id="manager-settings">
    <div class="card">
      <section class="settings mt-5">
        <div class="col-md-7">
          <form @submit.prevent>
            <h3>User Profile</h3>
            <div class="form-group row">
              <label for="first_name" class="col-sm-4 col-form-label">First name</label>
              <div class="col-sm-8">
                <input
                  v-model="selectedFirstName"
                  type="text"
                  class="form-control"
                  id="first_name"
                  placeholder="First name"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="last_name" class="col-sm-4 col-form-label">Last name</label>
              <div class="col-sm-8">
                <input
                  v-model="selectedLastName"
                  type="text"
                  class="form-control"
                  id="last_name"
                  placeholder="Last name"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="email" class="col-sm-4 col-form-label">Email</label>
              <div class="col-sm-8">
                <input
                  v-model="selectedEmail"
                  type="email"
                  class="form-control"
                  id="email"
                  placeholder="Email"
                  disabled
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="phone" class="col-sm-4 col-form-label">Phone number</label>
              <div class="col-sm-8">
                <input
                  v-model="selectedPhone"
                  type="tel"
                  class="form-control"
                  id="phone"
                  placeholder="Phone number"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="picture" class="col-sm-4 col-form-label">Picture</label>
              <div class="col-sm-8">
                <Avatar @new="reGetProfile" :photo="getUserProfile.photo">
                  <img
                    class="rounded-circle"
                    style="object-fit: cover"
                    :src="selectedPicture"
                    alt="profile picutre"
                  />
                </Avatar>
              </div>
            </div>

            <h3>Settings</h3>
            <!-- Email notifications and integration shoud only be visable for employers and admins -->
            <div class="form-group row">
              <label for="notifications" class="col-sm-4 col-form-label">Email Notifications</label>
              <div class="col-sm-8">
                <div class="custom-control custom-checkbox mt-2">
                  <input
                    id="notifications"
                    class="mr-2 custom-control-input"
                    type="checkbox"
                    aria-label
                    @change="settings.emailNotification = !settings.emailNotification"
                    :checked="settings.emailNotification"
                  />
                  <label class="custom-control-label" for="notifications"></label>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label for="date-format" class="col-sm-4 col-form-label">Date Format</label>
              <div class="col-sm-8">
                <select id="format_date" v-model="settings.dateFormat" class="form-control">
                  <option value="YY-MM-DD">YY-MM-DD</option>
                  <option value="YY/MM/DD">YY/MM/DD</option>
                  <option value="DD-MM-YY">DD-MM-YY</option>
                  <option value="DD/MM/YY">DD/MM/YY</option>
                  <option value="MM-DD-YY">MM-DD-YY</option>
                  <option value="MM/DD/YY">MM/DD/YY</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label for="time-zone" class="col-sm-4 col-form-label">Time Zone</label>
              <div class="col-sm-8">
                <v-select
                  ref="tzSelect"
                  placeholder="Select Timezone"
                  v-model="selectedTimezone"
                  :options="tzOptions"
                  :clearable="false"
                  :reduce="zone => zone"
                  :filterable="false"
                  label="utc_timezone"
                  @search="onTzSearch"
                  @open="onTzOpen"
                >
                  <template #option="{ utc_timezone }">
                    {{ utc_timezone }}
                  </template>
                  <template #selected-option="{ utc_timezone }">
                    {{ utc_timezone }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="d-flex">
              <button @click="saveChangesHandler" class="ml-auto btn btn-primary mb-3">
                Save Changes
              </button>
            </div>
          </form>
          <form @submit.prevent>
            <h3>Security</h3>
            <div class="form-group row">
              <label for="old" class="col-sm-4 col-form-label">Old Password</label>
              <div class="col-sm-8">
                <input
                  v-model="form.oldPassword"
                  type="password"
                  id="old_password"
                  placeholder="Enter old password"
                  class="form-control"
                  minlength="8"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="new" class="col-sm-4 col-form-label">New Password</label>
              <div class="col-sm-8">
                <input
                  v-model="form.newPassword1"
                  type="password"
                  class="form-control"
                  id="new"
                  placeholder="Enter new password"
                  minlength="8"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="confirm" class="col-sm-4 col-form-label">Re-type New Password</label>
              <div class="col-sm-8">
                <input
                  v-model="form.newPassword2"
                  type="password"
                  class="form-control"
                  id="confirm"
                  placeholder="Confirm password"
                  minlength="8"
                />
              </div>
            </div>
            <div class="d-flex">
              <button @click="changePassword" class="ml-auto btn btn-primary mb-3">
                Change Password
              </button>
            </div>
          </form>
          <form @submit.prevent>
            <h3>Delete account</h3>
            <div class="form-group row">
              <label for="delete" class="col-sm-4 col-form-label">Enter Password</label>
              <div class="col-sm-8">
                <input
                  type="password"
                  class="form-control"
                  id="delete"
                  placeholder="Enter password before deleting your account"
                />
              </div>
            </div>
            <div class="d-flex">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                class="ml-auto btn btn-danger mb-3"
              >
                Delete Account
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
          <div class="modal-body text-center">
            Please confirm that you want your account to be permanently deleted.
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-primary">Delete</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import { required, minLength } from 'vuelidate/lib/validators';

import moment from 'moment-timezone';
import { mapActions, mapGetters } from 'vuex';
import Avatar from './AdminSettingsAvatar';
import axios from 'axios';

import { TIME_ZONES } from '../../../constants';
import titleMixin from '../../../mixins/titleMixin';

export default {
  components: { Avatar },
  mixins: [titleMixin],
  title() {
    return 'Settings | Jobshark';
  },
  data: () => ({
    currentTimeName: '',
    timeZones: [],
    selectedTimezone: {
      id: 358,
      utc_timezone: '(UTC +02:00) Europe/Stockholm',
      time_zone: 'Europe/Stockholm',
    },
    defaultTimeZone: {
      name: '(GMT+01:00) Stockholm',
      timezone: 'Europe/Stockholm',
    },
    settings: {
      emailNotification: false,
      dateFormat: 'YY-MM-DD',
    },
    emailIntegration: {
      isEmailConnected: false,
      email: '',
      password: '',
    },

    form: {
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
    },
    selectedFirstName: '',
    selectedLastName: '',
    selectedEmail: '',
    selectedPhone: '',
    selectedPicture: 'https://jobshark.eu/img/comstream.svg',
    tzOptions: [],
    tzPage: 1,
    tzLastPage: 1,
    tzSearch: '',
    tzLoading: false,
    tzSearchTimeout: null,
  }),
  methods: {
    ...mapActions(['connectEmail', 'retrieveUserProfile', 'retrieveUserProfileMarketing']),
    fetchTimezones(reset = false) {
      if (this.tzLoading) return;
      if (!reset && this.tzPage > this.tzLastPage) return;
      this.tzLoading = true;
      if (reset) {
        this.tzPage = 1;
        this.tzLastPage = 1;
      }
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/all`, {
        method: 'post',
        data: { page: this.tzPage, count: 50, search_word: this.tzSearch },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          Accept: 'application/json',
        },
      })
        .then(res => {
          const raw = res.data.data !== undefined ? res.data.data : res.data;
          const items = Array.isArray(raw) ? raw : Object.values(raw);
          if (reset) {
            this.tzOptions = items;
          } else {
            const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
            const scrollTop = dropdown ? dropdown.scrollTop : 0;
            items.forEach(item => this.tzOptions.push(item));
            this.$nextTick(() => {
              if (dropdown) dropdown.scrollTop = scrollTop;
            });
          }
          this.tzLastPage = res.data.last_page;
          this.tzPage += 1;
        })
        .catch(() => {})
        .finally(() => {
          this.tzLoading = false;
        });
    },
    onTzSearch(search) {
      clearTimeout(this.tzSearchTimeout);
      this.tzSearchTimeout = setTimeout(() => {
        this.tzSearch = search;
        this.fetchTimezones(true);
      }, 300);
    },
    onTzOpen() {
      this.$nextTick(() => {
        const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
        if (!dropdown) return;
        dropdown.addEventListener('scroll', this.onTzScroll);
      });
    },
    onTzScroll(e) {
      const el = e.target;
      if (this.tzPage > this.tzLastPage) return;
      if (this.tzLoading) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        this.fetchTimezones();
      }
    },
    saveChangesHandler() {
      if (this.getAccType === 'admin' || this.getAccType === 'recruiter') {
        axios(`${process.env.VUE_APP_API_URL}/admin/update`, {
          method: 'post',
          data: {
            first_name: this.selectedFirstName,
            last_name: this.selectedLastName,
            email_notifications: this.settings.emailNotification,
            phone: this.selectedPhone,
            format_date: this.settings.dateFormat,
            timezone_id: this.selectedTimezone.id,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then(() => {
            this.retrieveUserProfile();
            this.$toasted.success('Profile updated', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        axios(`${process.env.VUE_APP_API_URL}/marketing/profile/update`, {
          method: 'post',
          data: {
            first_name: this.selectedFirstName,
            last_name: this.selectedLastName,
            email_notifications: this.settings.emailNotification,
            phone: this.selectedPhone,
            format_date: this.settings.dateFormat,
            timezone: this.selectedTimezone.timezone,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then(() => {
            this.retrieveUserProfile();
            this.$toasted.success('Profile updated', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    changePassword() {
      axios(`${process.env.VUE_APP_API_URL}/auth/changepassword`, {
        method: 'post',
        data: {
          old_password: this.form.oldPassword,
          new_password: this.form.newPassword1,
          new_confirm_password: this.form.newPassword2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$toasted.success('Password changed successfully', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error(`There was problem changing your password.`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    setSelectorOptions() {
      const selectorOptions = moment.tz
        .names()
        .reduce((memo, tz) => {
          memo.push({
            name: tz,
            offset: moment.tz(tz).utcOffset(),
          });

          return memo;
        }, [])
        .sort((a, b) => {
          return a.offset - b.offset;
        })
        .reduce((memo, tz) => {
          const timezone = tz.offset ? moment.tz(tz.name).format('Z') : '';

          return memo.concat(`${tz.name} (GMT${timezone})`);
        }, []);

      this.timeZones = selectorOptions;
    },
    connectToEmail() {
      this.connectEmail({
        email: this.emailIntegration.email,
        password: this.emailIntegration.password,
      }).then(response => {
        if (response.status == 422) {
          this.$toasted.error('Wrong email/password!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        } else {
          this.emailIntegration.isEmailConnected = true;
          this.$toasted.success('Email connected!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        }
      });
    },
    reGetProfile() {
      this.retrieveUserProfile().then(() => {
        if (
          this.getUserProfile.photo !== 'default.png' &&
          this.getUserProfile.photo !== null &&
          this.getUserProfile.photo !== 'null'
        ) {
          this.selectedPicture = `https://jobshark.eu/storage/avatars/${this.getUserProfile.photo}`;
        } else {
          this.selectedPicture = 'https://jobshark.eu/img/comstream.svg';
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      getAccType: 'getAccType',
      getUserProfile: 'getUserProfile',
    }),
    getTimeZones() {
      return TIME_ZONES;
    },
    getTimeZoneName() {
      // const position = this.getUserProfile.timezone.indexOf('(');
      return this.getUserProfile.timezone;
    },
  },
  mounted() {
    this.fetchTimezones(true);
    if (this.getAccType === 'admin' || this.getAccType === 'recruiter') {
      this.retrieveUserProfile().then(({ data }) => {
        this.selectedFirstName = this.getUserProfile.first_name;
        this.selectedLastName = this.getUserProfile.last_name;
        this.selectedEmail = this.getUserProfile.email;
        if (this.getUserProfile.phone) {
          this.selectedPhone = `+${this.getUserProfile.phone.replace(/\D/g, '')}`;
        }
        this.settings.emailNotification = Boolean(this.getUserProfile.email_notifications);

        if (data.photo === 'default.png') {
          this.selectedPicture = 'https://jobshark.eu/img/comstream.svg';
        } else if (data.photo === null) {
          this.selectedPicture = 'https://jobshark.eu/img/comstream.svg';
        } else {
          this.selectedPicture = `https://jobshark.eu/storage/avatars/${data.photo}`;
        }

        if (this.getUserProfile.format_date !== null) {
          this.settings.dateFormat = this.getUserProfile.format_date;
        }
        this.selectedTimezone = this.getUserProfile.timezone_data;
      });
    } else {
      this.retrieveUserProfileMarketing().then(({ data }) => {
        this.selectedFirstName = this.getUserProfile.first_name;
        this.selectedLastName = this.getUserProfile.last_name;
        this.selectedEmail = this.getUserProfile.email;
        if (this.getUserProfile.phone) {
          this.selectedPhone = `+${this.getUserProfile.phone.replace(/\D/g, '')}`;
        }
        this.settings.emailNotification = Boolean(this.getUserProfile.email_notifications);

        if (data.photo === 'default.png') {
          this.selectedPicture = 'https://jobshark.eu/img/comstream.svg';
        } else if (data.photo === null) {
          this.selectedPicture = 'https://jobshark.eu/img/comstream.svg';
        } else {
          this.selectedPicture = `https://jobshark.eu/storage/avatars/${data.photo}`;
        }

        if (this.getUserProfile.format_date !== null) {
          this.settings.dateFormat = this.getUserProfile.format_date;
        }
        this.selectedTimezone = this.getUserProfile.timezone_data;
      });
    }

    this.setSelectorOptions();

    // console.log(TIME_ZONES);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.col-sm-8 {
  position: relative;

  .fa-plug {
    position: absolute;
    font-size: 1rem;
    top: 10px;
    right: 22px;
  }
}

.connected {
  color: $color-status-active;
}
.disconnected {
  color: $color-status-closed;
}

.disconnected {
  color: $color-status-closed;
}

.settings {
  font-family: $font-family-sans-lato;
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;

  h3 {
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #ddd;
    margin: 30px 0 12px 0;
    padding-bottom: 12px;
  }
  h5 {
    font-size: 2rem;
    font-family: $font-family-sans-serif;
    margin-bottom: 22px;
  }

  .form-group {
    font-family: $font-family-sans-lato;

    .col-form-label {
      font-size: 14px;
      font-weight: 700;
    }
  }
  /* .d-flex {
    .btn:first-of-type {
      background: $color-base-blue;
      border: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .btn:nth-of-type(2) {
      background: $color-orange;
      border: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  } */
  /*  .btn-success {
    background: $color-base-blue;
    border-color: $color-base-blue;
  } */
}
.modal-body {
  font-size: 14px;
  padding: 20px 12px;
}

.candidate-picture {
  position: relative;
  width: 64px;
  height: 64px;
  margin-right: 12px !important;
  flex-shrink: 0;
  .btn-success {
    margin-right: 10px;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}
</style>
